/*!
 * CSTag - engraved round dog tag, front and back side by side, as an inline SVG string.
 * Leatherius Woodman collar-set configurator (pin-buckle leather collars). Dependency-free ES5.
 *
 *   var svg = CSTag.render({ front:'Cooper', back:['Call my mom!','713.992.7883'], font:'Straight'|'Cursive',
 *                            metal:'Gold'|'Anti-Brass'|'Silver', size:'lg'|'sm' });
 *   CSTag.onFontsReady(function(){ ...re-render... });
 *
 * Layout follows the studio photos (FRONT SIDE / BACK SIDE): the name alone on the front, Oregon capitals
 * or Brilliant script; the back in small Oregon capitals in both modes. Fonts are the workshop's laser
 * fonts, declared on the page as 'LW Oregon' and 'LW Brilliant' (see product-collar-set.liquid).
 */
(function (win) {
  'use strict';

  // advance widths per 1000 em, ASCII 32..126, from lw-oregon.woff2 (OR) / lw-brilliant.woff2 (BR); used until the fonts load
  var ADV={"OR":[200,235,381,700,546,768,540,244,286,286,369,435,244,320,244,360,568,323,551,540,565,540,568,490,575,568,244,244,298,435,298,495,820,600,561,538,568,520,520,570,581,240,510,573,520,666,583,568,554,568,550,530,510,580,600,800,580,580,540,350,360,350,350,435,500,600,561,539,568,520,520,570,581,240,510,573,530,666,583,568,554,568,550,530,510,580,600,800,580,580,540,500,240,500,500],"BR":[180,228,127,424,427,499,439,80,231,212,185,382,97,382,111,203,394,206,440,403,391,409,391,336,385,380,176,176,266,382,266,325,628,542,601,464,618,451,369,447,492,279,271,459,445,816,589,471,455,491,539,495,382,574,503,799,634,478,527,291,267,279,409,443,139,361,392,243,417,243,245,343,426,208,177,365,256,627,421,311,397,384,259,206,244,395,339,544,449,348,342,291,227,314,395]};
  var CAP_OR = 0.72, CAP_BR = 0.723;
  var FONT_SANS = "'LW Oregon',Barlow,'DM Sans','Helvetica Neue',Arial,sans-serif";
  var FONT_SCRIPT = "'LW Brilliant','Ms Madi','Great Vibes','Brush Script MT',cursive";
  var FACE_SANS = '400 100px "LW Oregon"', FACE_SCRIPT = '400 100px "LW Brilliant"';

  // metals, sampled from the SILVER / GOLD / ANTI-BRASS studio photo; eng = laser mark, lip = its shadow
  var METAL = {
    'Gold': { hi: '#fdecb2', mid: '#e0b84e', lo: '#a87a22', rim: '#7d5a17', eng: '#fff6dc', lip: '#6a4d14' },
    'Anti-Brass': { hi: '#ddd0a6', mid: '#a8925e', lo: '#776237', rim: '#55452a', eng: '#f6eedb', lip: '#4a3a1c' },
    'Silver': { hi: '#fbfbfa', mid: '#cfd0ce', lo: '#94958f', rim: '#6c6d69', eng: '#6a6c6c', lip: '#ffffff' }
  };

  var mctx = null, mcache = {};
  function fontReady(face) { try { return !!(win.document && document.fonts && document.fonts.check(face)); } catch (e) { return false; } }
  function width(script, s) {   // advance width in em
    var key = (script ? 'b|' : 'o|') + s;
    if (mcache[key] != null) return mcache[key];
    var w = 0, T = script ? ADV.BR : ADV.OR, i, c, face = script ? FACE_SCRIPT : FACE_SANS;
    for (i = 0; i < s.length; i++) { c = s.charCodeAt(i); if (c < 32 || c > 126) c = 110; w += T[c - 32]; }
    w /= 1000;
    if (fontReady(face)) {
      try { if (!mctx) mctx = document.createElement('canvas').getContext('2d'); mctx.font = face; var r = mctx.measureText(s); if (r && r.width > 0) w = r.width / 100; } catch (e) { }
    }
    return (mcache[key] = w);
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function r2(v) { return Math.round(v * 100) / 100; }
  function clean(s) { return s == null ? '' : String(s).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, ''); }
  var UID = 0, PFX = 'cst' + Math.floor(Math.random() * 1e6).toString(36);

  // brushed grain: fine horizontal strokes, the same for every tag (seeded)
  var GRAIN = (function () {
    var s = 20261023, h = '', y, o;
    function rnd() { s = (s * 1103515245 + 12345) & 0x7fffffff; return s / 0x7fffffff; }
    for (y = 0; y < 100; y += 0.9) {
      o = (rnd() * 0.07).toFixed(3);
      h += '<rect x="0" y="' + y.toFixed(1) + '" width="100" height="' + (0.25 + rnd() * 0.35).toFixed(2) + '" fill="' + (rnd() < 0.5 ? '#fff' : '#000') + '" opacity="' + o + '"/>';
    }
    return h;
  })();

  var R = 50, GAP = 22, CY = 82;            // tag radius, gap between the two tags, centre line
  var VBW = 4 * R + GAP + 8, VBH = CY + R + 16;

  // one line of engraving: centred text that fits the circle at its height
  function fitLine(s, script, cap, yBase, maxFrac) {
    var capEm = script ? CAP_BR : CAP_OR, fs = cap / capEm, track = script ? 0 : 0.04;
    var w = (width(script, s) + track * Math.max(0, s.length - 1)) * fs;
    var top = yBase - cap, far = Math.max(Math.abs(top - CY), Math.abs(yBase - CY));
    var half = Math.sqrt(Math.max(0, R * R - far * far)), maxW = 2 * half * (maxFrac || 0.82);
    if (w > maxW) { fs *= maxW / w; w = maxW; }
    return { s: s, fs: fs, w: w, y: yBase, script: script, track: track };
  }
  function textEl(L, cx) {
    var a = ' x="' + r2(cx) + '" y="' + r2(L.y) + '" font-family="' + (L.script ? FONT_SCRIPT : FONT_SANS) + '" font-size="' + r2(L.fs) + '" text-anchor="middle"';
    if (!L.script && L.s.length > 1) a += ' textLength="' + r2(L.w) + '" lengthAdjust="spacing"';
    return '<text' + a + '>' + esc(L.s) + '</text>';
  }

  function front(name, cursive) {
    var s = clean(name) || (cursive ? 'Bella' : 'BELLA');
    if (!cursive) s = s.toUpperCase();
    var cap = cursive ? 20 : 13.5, base = CY + cap / 2 + (cursive ? 1 : 0);
    var L = fitLine(s, cursive, cap, base, cursive ? 0.84 : 0.8);
    // a long name shrinks: keep it optically centred
    if (L.fs < cap / (cursive ? CAP_BR : CAP_OR)) L.y = CY + L.fs * (cursive ? CAP_BR : CAP_OR) / 2 + (cursive ? 1 : 0);
    return [L];
  }
  function back(lines) {
    var raw = [], i;
    for (i = 0; i < lines.length; i++) { var s = clean(lines[i]).toUpperCase(); if (s) raw.push(s); }
    var n = raw.length; if (!n) return [];
    var cap = [10.5, 9.2, 8][n - 1], step = cap * 1.85, y0 = CY - (n - 1) * step / 2 + cap / 2, out = [];
    for (i = 0; i < n; i++) out.push(fitLine(raw[i], false, cap, y0 + i * step, 0.8));
    // a three-line back keeps one size, like the laser template
    var m = 1e9; for (i = 0; i < n; i++) m = Math.min(m, out[i].fs);
    for (i = 0; i < n; i++) if (out[i].fs > m * 1.12) { out[i].w *= m * 1.12 / out[i].fs; out[i].fs = m * 1.12; }
    return out;
  }

  function tag(cx, M, id, lines, ghost) {
    var h = '', hy = CY - R + 7.5;
    // jump ring (behind), soft shadow, the disc, its rim
    h += '<circle cx="' + cx + '" cy="' + (hy - 11) + '" r="11" fill="none" stroke="#2c2a27" stroke-width="2.6"/>';
    h += '<circle cx="' + (cx - .5) + '" cy="' + (hy - 11.4) + '" r="11" fill="none" stroke="#8b867c" stroke-width=".6" stroke-dasharray="14 60" stroke-dashoffset="44"/>';
    h += '<circle cx="' + (cx + 1.2) + '" cy="' + (CY + 2.4) + '" r="' + R + '" fill="#3c2a16" opacity=".22" filter="url(#' + id + 'b)"/>';
    h += '<circle cx="' + cx + '" cy="' + CY + '" r="' + R + '" fill="url(#' + id + 'g)"/>';
    h += '<g clip-path="url(#' + id + 'c' + cx + ')"><g transform="translate(' + (cx - R) + ' ' + (CY - R) + ')">' + GRAIN + '</g></g>';
    h += '<circle cx="' + cx + '" cy="' + CY + '" r="' + (R - 1.1) + '" fill="none" stroke="url(#' + id + 'r)" stroke-width="2.2"/>';
    h += '<circle cx="' + cx + '" cy="' + CY + '" r="' + (R - .2) + '" fill="none" stroke="' + M.rim + '" stroke-opacity=".55" stroke-width=".5"/>';
    // the hole with the ring passing through it
    h += '<circle cx="' + cx + '" cy="' + hy + '" r="3.3" fill="#2a2621"/><circle cx="' + cx + '" cy="' + hy + '" r="3.3" fill="none" stroke="' + M.lo + '" stroke-width=".6"/>';
    h += '<path d="M' + (cx - 2.6) + ' ' + (hy - 1.2) + 'Q' + cx + ' ' + (hy + 1.6) + ' ' + (cx + 2.6) + ' ' + (hy - 1.2) + '" fill="none" stroke="#2c2a27" stroke-width="2.4" stroke-linecap="round"/>';
    if (!lines.length) return h;
    var op = ghost ? ' opacity=".32"' : '', i;
    h += '<g fill="' + M.lip + '" opacity="' + (ghost ? .1 : .3) + '" transform="translate(0 .5)">';
    for (i = 0; i < lines.length; i++) h += textEl(lines[i], cx);
    h += '</g><g fill="' + M.eng + '"' + op + '>';
    for (i = 0; i < lines.length; i++) h += textEl(lines[i], cx);
    return h + '</g>';
  }

  function render(o) {
    o = o || {};
    var M = METAL[o.metal] || METAL.Gold, cursive = o.font === 'Cursive', id = PFX + (++UID);
    var b = o.back || [], fl = front(o.front, cursive), bl = back(b), ghost = !bl.length;
    if (ghost && o.hint !== false) bl = back(o.backHint || ['Call my mom!', '555.201.4477', '']).map(function (l) { l.fs *= 0.85; l.w *= 0.85; return l; });
    var x1 = 4 + R, x2 = 4 + 3 * R + GAP;
    var label = 'Tag preview. Front: ' + fl[0].s + (ghost ? '. Back: blank' : '. Back: ' + bl.map(function (l) { return l.s; }).join(', '));
    var h = '<svg xmlns="http://www.w3.org/2000/svg" class="cs-tag' + (o.size === 'sm' ? ' cs-tag-s' : '') + '" viewBox="0 0 ' + VBW + ' ' + VBH + '" role="img" aria-label="' + esc(label) + '"><title>' + esc(label) + '</title><defs>';
    h += '<radialGradient id="' + id + 'g" cx=".38" cy=".32" r=".8"><stop offset="0" stop-color="' + M.hi + '"/><stop offset=".55" stop-color="' + M.mid + '"/><stop offset="1" stop-color="' + M.lo + '"/></radialGradient>';
    h += '<linearGradient id="' + id + 'r" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".65"/><stop offset=".5" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="' + M.rim + '" stop-opacity=".7"/></linearGradient>';
    h += '<filter id="' + id + 'b" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur stdDeviation="2.2"/></filter>';
    h += '<clipPath id="' + id + 'c' + x1 + '"><circle cx="' + x1 + '" cy="' + CY + '" r="' + R + '"/></clipPath><clipPath id="' + id + 'c' + x2 + '"><circle cx="' + x2 + '" cy="' + CY + '" r="' + R + '"/></clipPath></defs>';
    h += tag(x1, M, id, fl, false) + tag(x2, M, id, bl, ghost);
    h += '<g font-family="\'DM Sans\',Arial,sans-serif" font-size="8.5" fill="#8a8575" text-anchor="middle" letter-spacing=".8"><text x="' + x1 + '" y="' + (VBH - 2) + '">FRONT</text><text x="' + x2 + '" y="' + (VBH - 2) + '">' + (ghost ? 'BACK · OPTIONAL' : 'BACK') + '</text></g>';
    return h + '</svg>';
  }

  var cbs = [], done = false, started = false;
  function onFontsReady(cb) {
    if (typeof cb === 'function') cbs.push(cb);
    if (done) return flush();
    if (!(win.document && document.fonts && document.fonts.load && win.Promise)) { done = true; return flush(); }
    if (started) return; started = true;
    var p = [];
    try { p.push(document.fonts.load(FACE_SANS, 'BELLA 0123456789')); p.push(document.fonts.load(FACE_SCRIPT, 'Bella')); } catch (e) { }
    var fin = function () { done = true; mcache = {}; flush(); };
    Promise.all(p).then(fin, fin);
  }
  function flush() { var a = cbs; cbs = []; for (var i = 0; i < a.length; i++) { try { a[i](); } catch (e) { } } }

  win.CSTag = { render: render, onFontsReady: onFontsReady, metals: METAL, version: '1.0.0' };
  try { onFontsReady(); } catch (e) { }
})(typeof window !== 'undefined' ? window : this);
